import React from 'react';
import PropTypes from 'prop-types';
import VideoListItem from './VideoListItem';
import ListHeader from '../ListHeader';

const VideoList = ({useEmbed, videos}) => (
  <div>
    <ListHeader href="/videos" text="Popular Videos" />
    <ul>
      {videos.map((video, i) => (
        <li key={`popular-video-${i}`}>
          <VideoListItem useEmbed={useEmbed} video={video} />
        </li>
      ))}
    </ul>
  </div>
);

VideoList.propTypes = {
  useEmbed: PropTypes.bool,
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
      duration: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

VideoList.defaultProps = {
  useEmbed: false,
};

export default VideoList;



// WEBPACK FOOTER //
// ./src/components/videos/VideoList.js